import React, { Component } from 'react';
import ErrorMessage from '../common/ErrorMessage';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import poweredLogo from '../../img/powered-by-logo.png';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withRouter } from 'react-router-dom'


const src = localStorage.logo ? localStorage.logo : `/Home/GetLogo`;
const styles = {
  paper: {
    marginTop: '50px',
    padding: '60px 30px ',
  },
  header: {
    fontWeight: '300',
    fontSize: '28px',
    marginBottom: '0',
    marginTop: '0',
  },
  logo: {
    width: '200px',
    paddingTop: '15px',
  },
  paragraph: {
    fontSize: '15px',
    marginBottom: '0',
  },
  button: {
    margin: '30px 10px',
    display: 'inline-block',
  },
  bottom: {
    marginTop: '20px',
  },
};

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newPassword: '',
      passwordConfirmation: '',
      errorPassword: '',
      errorPasswordConfirmation: '',
      currentPassword: '',
      errorCurrentPassword: '',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordConfirmationChange = this.handlePasswordConfirmationChange.bind(this);
    this.handleCurrentPasswordChange = this.handleCurrentPasswordChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    const newPassword = this.state.newPassword.trim();
    const passwordConfirmation = this.state.passwordConfirmation.trim();
    const currentPassword = this.state.currentPassword.trim();

    if (!newPassword || !passwordConfirmation || !currentPassword) {
      if (!newPassword) {
        this.setState({ errorNewPassword: 'New Password Required' });
      } else {
        this.setState({ errorNewPassword: '' });
      }

      if (!passwordConfirmation) {
        this.setState({ errorPasswordConfirmation: 'Confirm Password Required' });
      } else {
        this.setState({ errorPasswordConfirmation: '' });
      }

      if (!currentPassword) {
        this.setState({ errorCurrentPassword: 'Current Password Required' });
      } else {
        this.setState({ errorCurrentPassword: '' });
      }

      return;
    } else if (newPassword !== passwordConfirmation) {
      this.setState({ errorNewPassword: 'Passwords do not match' });
      this.setState({ errorPasswordConfirmation: 'Passwords do not match' });

      return;
    } else {
      this.props.passwordRequest({ currentPassword, newPassword });
    }

    this.setState({
      newPassword: '',
      passwordConfirmation: '',
      errorNewPassword: '',
      errorPasswordConfirmation: '',
      currentPassword: '',
      errorCurrentPassword: '',
    });
  }

  handleCurrentPasswordChange(e) {
    this.setState({ currentPassword: e.target.value });
    if (this.state.errorCurrentPassword) {
      this.setState({ errorCurrentPassword: '' });
    }
  }

  handlePasswordChange(e) {
    this.setState({ newPassword: e.target.value });
    if (this.state.errorNewPassword) {
      this.setState({ errorNewPassword: '' });
    }
  }

  handleCancel(e) {    
    this.props.history.goBack();
  }

  handlePasswordConfirmationChange(e) {
    this.setState({ passwordConfirmation: e.target.value });
    if (this.state.errorPasswordConfirmation) {
      this.setState({ errorPasswordConfirmation: '' });
    }
  }

  renderErrors(errors) {
    if (errors) {
      if (Array.isArray(errors)) {
        return errors.map((error, i) => <ErrorMessage key={i} error={error} />);
      } else {
        return <ErrorMessage error={errors} />;
      }
    }
  }

  render() {
    const { error, currentlySending, loading } = this.props;
    const {
      newPassword,
      errorNewPassword,
      passwordConfirmation,
      errorPasswordConfirmation,
      currentPassword,
      errorCurrentPassword,
    } = this.state;

    return (
      <div className="col-xs-10 col-sm-6 col-md-5 col-lg-5">
        <div className="box">
          <Paper elevation={3} style={styles.paper}>
            <form action="#" method="POST" onSubmit={this.handleSubmit}>
              <div className="row center-xs">
                <div className="col-xs-12">
                  <div className="box">
                    <h2 style={styles.header}>Change Password</h2>
                    <p style={styles.paragraph}>Please enter a new password</p>
                  </div>
                  <br />
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    {currentlySending || loading ? (
                      <CircularProgress size={25} thickness={5} />
                    ) : (
                        this.renderErrors(error)
                      )}
                  </div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box" style={{ margin: '10px 0 10px' }}>
                    <FormControl
                      fullWidth
                      error={errorCurrentPassword ? true : false}
                      aria-describedby="current-password"
                    >
                      <InputLabel shrink htmlFor="current-password-label">
                        Current Password
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="current-password"
                        value={currentPassword}
                        onChange={this.handleCurrentPasswordChange}
                        type="password"
                      />
                      <FormHelperText id="current-password-error-text">
                        {errorCurrentPassword}
                      </FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box" style={{ margin: '0 0 10px' }}>
                    <FormControl
                      fullWidth
                      error={errorNewPassword ? true : false}
                      aria-describedby="new-password"
                    >
                      <InputLabel shrink htmlFor="new-password-label">
                        New Password
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="new-password"
                        value={newPassword}
                        onChange={this.handlePasswordChange}
                        type="password"
                      />
                      <FormHelperText id="password-error-text">{errorNewPassword}</FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box">
                    <FormControl
                      fullWidth
                      error={errorPasswordConfirmation ? true : false}
                      aria-describedby="password-confirmation"
                    >
                      <InputLabel shrink htmlFor="password-confirmation-label">
                        Confirm Password
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="password-confirmation"
                        value={passwordConfirmation}
                        onChange={this.handlePasswordConfirmationChange}
                        type="password"
                      />
                      <FormHelperText id="password-error-text">
                        {errorPasswordConfirmation}
                      </FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    <Button
                      variant="contained"
                      type="submit"
                      id="submit-button"
                      style={styles.button}
                      color="primary"
                      disabled={currentlySending || loading ? true : false}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="contained"
                      style={styles.button}
                      id="cancel-button"
                      color="primary"
                      onClick={this.handleCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
                <div className="col-xs-8">
                  <div className="box">
                    <img src={src} alt="logo" style={styles.logo} />
                    <p />
                  </div>
                </div>
              </div>
            </form>
          </Paper>
          <a href="http://defisolutions.com" target="_blank" rel="noopener noreferrer">
            <img src={poweredLogo} style={styles.bottom} alt="logo" />
          </a>
        </div>
      </div>
    );
  }
}

export default withRouter(ChangePassword);
